import ControleBlock from "../components/blocks/ControleBlock";

const ControlesOverview = () => {

    return (<>
        <ControleBlock/>
    </>)
}
export default ControlesOverview